export interface IServerRenderSettings {
    notFoundTemplateNames: string[];

    renderBreakpoints: {
        mobile: number;
        desktop: number;
    };
}
const serverRenderSettings: IServerRenderSettings = {
    notFoundTemplateNames: ['not-found', 'not_found'],

    renderBreakpoints: {
        mobile: 768, // We should get these from config but ResponsiveContext can't handle em values
        desktop: 1920, // We should get these from config but ResponsiveContext can't em values
    },
};

export default serverRenderSettings;
